export default __webpack_public_path__ + "static/media/weather.827833fe.png";